import { render, staticRenderFns } from "./AdditionalComponents.vue?vue&type=template&id=8e03a32a&scoped=true&"
import script from "./AdditionalComponents.vue?vue&type=script&lang=js&"
export * from "./AdditionalComponents.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalComponents.vue?vue&type=style&index=0&id=8e03a32a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e03a32a",
  null
  
)

export default component.exports